import Image from "src/components/Image";
import { entitiesUrl } from "src/utils/formatUrl";

import { EntityData } from "../useGetEntitiesData";

export default function Entity({ entity }: EntityData) {
	return <Image src={entitiesUrl(entity)} sx={{ width: 80, height: 40 }} fit='contain' />;
}
